import React from 'react';
import AbstractComponent from '../../AbstractComponent';
import InputCheckBox from '../../layout/input/InputCheckBox';

import AtivoEnum from '../../../helper/enumerador/AtivoEnum';

class OpcaoPagamentoPagarNaEntrega extends AbstractComponent {        
    onChange(item, index) {        
        let lista = this.props.lista;
        let opcao = lista[index];

        opcao.ativo = item.ativo === AtivoEnum.SIM ? AtivoEnum.NAO : AtivoEnum.SIM;

        lista.splice(index, 1, opcao);                

        this.props.onChange(lista);        
    }                

    render() {
        return(       
            <div 
                id="modalidadePagamento" 
                className="col-md-12 
                           col-xs-12
                           col-sm-12
                           col-lg-12">
                <div 
                    className="row" 
                    style={{
                        padding: '0px 15px', 
                        backgroundColor: '#e6e4e6',
                        marginBottom: '10px',
                        overflowX: 'none'                        
                    }}
                >
                    <strong>
                        {this.props.opcaoPagamento}
                    </strong>
                </div>                
                            
                <div className="row">
                    {
                        this.props.lista.map((item, index) => {                        
                            return (                            
                                <InputCheckBox
                                    key={index}
                                    md={4} 
                                    xs={12}
                                    sm={4} 
                                    lg={4}                                    
                                    value={item.descricao_modalidade}
                                    checked={item.ativo === 'Sim'}                                    
                                    onChange={() => this.onChange(item, index)}                   
                                >                    
                                    {item.descricao_modalidade}
                                </InputCheckBox>
                            )
                        })
                    }
                </div>                    
            </div>
        )
    }
}

export default OpcaoPagamentoPagarNaEntrega;